import { Outlet } from 'react-router-dom'
// import Navigation from '../components/usables/Navigation'
import Header from '../components/usables/Header'

export default function MainLayout() {
  return (
    <>
    <Header />
    {/* <Navigation /> */}
    <main className='p-4 h-[calc(100vh-5.625rem)]'>
      <Outlet />
    </main>
    </>
  )
}